import { render, staticRenderFns } from "./InsertionPlaceholder.vue?vue&type=template&id=18b8ec8c&"
import script from "./InsertionPlaceholder.vue?vue&type=script&lang=js&"
export * from "./InsertionPlaceholder.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports